/**
 * Alerts
 */

export enum AlertStatus {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

export enum ComparisonOperator {
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
}

export const EMPTY_ALERT_STATE = {
  Email: [],
  Push: [],
  SMS: [],
  InApp: [],
  WebPush: [],
  Embedded: [],
};

export enum ThresholdType {
  Number = 'numberThreshold',
  Percentage = 'percentageThreshold',
}

export enum Preposition {
  Within = 'within',
  WithinEvery = 'within every',
  After = 'after',
}

export const DEFAULT_STATUS_FORM_VALUE = false;
export const DEFAULT_THRESHOLD_FORM_VALUE = '0';
export const DEFAULT_FREQUENCY_FORM_VALUE = '24';

export enum MetricName {
  EmailOpenRate = 'EmailOpenRate',
  EmailClickRate = 'EmailClickRate',
  EmailBounceRate = 'EmailBounceRate',
  EmailUnsubscribeRate = 'EmailUnsubscribeRate',
  TotalEmailSend = 'TotalEmailSend',
  TotalEmailOpen = 'TotalEmailOpen',
  TotalEmailClick = 'TotalEmailClick',
  PushOpenRate = 'PushOpenRate',
  PushBounceRate = 'PushBounceRate',
  TotalPushSend = 'TotalPushSend',
  TotalPushOpen = 'TotalPushOpen',
  SMSClickRate = 'SMSClickRate',
  SMSBounceRate = 'SMSBounceRate',
  SMSUnsubscribeRate = 'SMSUnsubscribeRate',
  TotalSMSSend = 'TotalSMSSend',
  InAppClickRate = 'InAppClickRate',
  TotalEmailComplaintRate = 'TotalEmailComplaintRate',
  TotalInAppSend = 'TotalInAppSend',
  TotalInAppClick = 'TotalInAppClick',
  TotalWebPushClick = 'TotalWebPushClick',
  TotalWebPushSend = 'TotalWebPushSend',
  TotalEmbeddedImpression = 'TotalEmbeddedImpression',
}

/**
 * May be removed later if backend starts returning this data
 */
export const METRICS_TO_DISPLAY_NAMES = {
  // Email
  [MetricName.EmailOpenRate]: 'Open rate',
  [MetricName.EmailClickRate]: 'Click rate',
  [MetricName.EmailBounceRate]: 'Bounce rate',
  [MetricName.EmailUnsubscribeRate]: 'Unsubscribe rate',
  [MetricName.TotalEmailComplaintRate]: 'Complaint rate',
  [MetricName.TotalEmailSend]: 'Sends',
  [MetricName.TotalEmailOpen]: 'Opens',
  [MetricName.TotalEmailClick]: 'Clicks',

  // Push
  [MetricName.PushOpenRate]: 'Open rate',
  [MetricName.PushBounceRate]: 'Bounce rate',
  [MetricName.TotalPushSend]: 'Sends',
  [MetricName.TotalPushOpen]: 'Opens',

  // SMS
  [MetricName.SMSClickRate]: 'Click rate',
  [MetricName.SMSBounceRate]: 'Bounce rate',
  [MetricName.SMSUnsubscribeRate]: 'Unsubscribe rate',
  [MetricName.TotalSMSSend]: 'Sends',

  // In-app
  [MetricName.InAppClickRate]: 'Click rate',
  [MetricName.TotalInAppSend]: 'Sends',
  [MetricName.TotalInAppClick]: 'Clicks',

  // Web push
  [MetricName.TotalWebPushClick]: 'Clicks',
  [MetricName.TotalWebPushSend]: 'Sends',

  // Embedded
  [MetricName.TotalEmbeddedImpression]: 'Retrieved messages',
} as const;

export enum ComparatorDisplayText {
  LessThan = 'less than',
  GreaterThan = 'greater than',
}

/**
 * Authentication types
 */

export const AUTH_TYPE = { BASIC: 'Basic', OAUTH2: 'OAuth2', NONE: 'NoAuth' };

export const AUTH_TYPE_DROPDOWN_OPTIONS = [
  {
    id: 'none',
    label: 'None',
    value: AUTH_TYPE.NONE,
  },
  {
    id: 'basic',
    label: 'Basic',
    value: AUTH_TYPE.BASIC,
  },
  {
    id: 'oauth',
    label: 'OAuth 2.0',
    value: AUTH_TYPE.OAUTH2,
  },
];
